import React, { useEffect, useState, useContext } from "react";
import "../assest/Header.css";
import bikuyumlogo from '../img/logo.webp';
import { Link, useNavigate } from "react-router-dom";
import Categories from "../pages/categories/Categories.js";
import { FaHeart } from 'react-icons/fa';

import { FaEuroSign } from "react-icons/fa";
import { FaDollarSign } from "react-icons/fa";

// RTK Query hooks
import { useGetCartQuery } from '../services/cartApi';
import { useLogoutMutation } from '../services/userApi';

import goldicon from '../components/gold-ingot.png';
import SearchBar from "./SearchBar.js";
// import { Container } from "@mui/material";
import { useToast } from "../context/ToastContext.js";
import { getApiUrl } from "../config.js";

const Header = () => {

  const navigate = useNavigate();
  const { showToast } = useToast();

  // RTK Query hooks kullanarak sepeti alıyoruz
  const { data: cart = [] } = useGetCartQuery();
  const [logout, { isLoading: isLoggingOut }] = useLogoutMutation();

  const [exchangeRates, setExchangeRates] = useState({
    USD: null,
    EUR: null,
    GOLD: null,
  });
  const words = [
    "💎 Rengarenk Küpe Modelleri. Bu Işıltıyı Hakediyorsunuz💎",
    "💎 Saat Modelleri Kombinin Vazgeçilmezi💎",
    "💎 Zarif Kolye Modelleri, Birbirinden Farklı, Birbirinden Özgün 💎",
    "💎 Yüzük Modelleri, Her Tarza, Her Modaya 💎",
    "💎 Kelepçe Modelleri, Zarif Değerli 💎",
    "💎 Bileklik Modelleri İnci, İtalya, Zarif 💎"
  ];

  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [showAuthDropdown, setShowAuthDropdown] = useState(false);


  useEffect(() => {
    const fetchExchangeRates = async () => {
      try {

        const response = await fetch(`${getApiUrl()}/exchange_rates`);
        const data = await response.json();
        
        setExchangeRates({
          USD: data.USD.selling,
          EUR: data.EUR.selling,
          GOLD: data.GOLD.selling,
        });
      } catch (error) {
        console.error('Döviz kurları alınamadı:', error);
      }
    };

    fetchExchangeRates();
    const intervalId = setInterval(fetchExchangeRates, 60000);

    return () => clearInterval(intervalId);
  }, []);


  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, [navigate]);


  const handleLogin
    = () => {

      navigate("/login");

    };

  const handleLogout = async () => {
    try {
      await logout().unwrap();
      setIsLoggedIn(false);
      showToast("Başarı ile çıkış yapıldı", "success");
      navigate("/");
    } catch (error) {
      console.error('Çıkış yapılamadı:', error);
      showToast("Çıkış sırasında bir hata oluştu.", "error");
    }
  };


  const cartCount = cart.reduce((total, product) => total + (product.quantity || 1), 0);


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) =>
        prevIndex === words.length - 1 ? 0 : prevIndex + 1
      );
    }, 1500);

    return () => clearInterval(interval);
  }, [words.length]);
  const toggleDropdown = () => {
    setShowAuthDropdown((prev) => !prev);
  };

  const closeDropdown = () => {
    setShowAuthDropdown(false);
  };

  return (
    <>
      {/* <Container> */}
        <div className="header position-sticky top-0 start-0 w-100">

          <div className="top-bar d-flex justify-content-between align-items-center bg-white py-2 px-4">
            <div className="top-bar-left d-flex gap-3">
              <a className="fs-6 fs-7 text-decoration-none" href={'/institutional'}>Kurumsal</a>
              <a className="fs-6 fs-7 text-decoration-none" href={'https://panel.bikuyum.com/magaza/'}>Mağaza Girişi</a>
            </div>

            <div className="top-bar-center">
              <span className="center-text fs-6 fs-7">
                {words[currentWordIndex]}
              </span>
            </div>
            <div className="top-bar-right d-md-flex d-none align-items-center">

              <div className="d-flex align-items-center gap-1">
                <img src={goldicon} alt="Gold" style={{ width: '20px' }} />
                <span className="d-flex align-items-center gap-1 m-0">Gram Altın <span className="doviz fs-6 fs-7">  {exchangeRates.GOLD} TL</span></span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <FaDollarSign style={{ color: 'green', verticalAlign: 'middle', fontSize: '18px' }} />
                <span className="d-flex align-items-center gap-1 m-0"> Dolar <span className="doviz fs-6 fs-7"> {exchangeRates.USD} TL</span></span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <FaEuroSign style={{ color: 'blue', verticalAlign: 'middle', fontSize: '16px' }} />
                <span className="d-flex align-items-center gap-1 m-0"> Euro <span className="doviz fs-6 fs-7">{exchangeRates.EUR} TL</span></span>
              </div>


            </div>
          </div>

          <div className="center">
            <div className="logo-div ms-md-5 ms-1" >
              <a href="/">
                <img className="logo" src={bikuyumlogo} alt="Logo" />
              </a>
            </div>

            <div className="searchbarr"><SearchBar></SearchBar></div>
            <div className="cart-header gap-sm-3 gap-3">
              <div>
                <div className="auth-dropdown d-flex gap-2 p-0"
                  onMouseEnter={() => window.innerWidth > 768 && setShowAuthDropdown(true)}
                  onMouseLeave={() => window.innerWidth > 768 && setShowAuthDropdown(false)}
                  style={{ position: 'relative' }}
                >
                  <a> <i className="fas fa-user fs-6 fs-7" onClick={() => {
                    if (!isLoggedIn) toggleDropdown();
                    else navigate("/user");
                  }}></i></a>
                  {isLoggedIn ? (
                    <>
                      <span className="fs-6 fs-7" onClick={() => navigate("/user")}> Hesabım </span>
                      <div className="auth-dropdown-menu " style={{ position: 'absolute', left: '0', top: '100%', zIndex: 1000 }}>
                        <Link to="/user" className="dropdown-item fs-6 fs-7 p-2">Hesabım</Link>
                        <Link to="/user?tab=addresses" className="dropdown-item fs-6 fs-7 p-2">Adreslerim</Link>
                        <Link to="/user?tab=orders" className="dropdown-item fs-6 fs-7 p-2">Siparişlerim</Link>
                        <div className="dropdown-item logout fs-6 fs-7 p-2"
                          onClick={() => {
                            closeDropdown();
                            handleLogout();
                          }}>
                          Çıkış Yap
                        </div>
                      </div>

                    </>
                  ) : (

                    <span className="auth-title fs-6 fs-7"> Giriş Yap</span>)}
                  {showAuthDropdown && !isLoggedIn && (

                    <div className="auth-dropdown-menu d-flex flex-column list-group"
                      style={{ position: 'absolute', left: '0', top: '100%', zIndex: 1000 }}
                    >
                      <Link to="/register" className="dropdown-item list-group-item list-group-item-action fs-6 fs-7" onClick={() => {
                        closeDropdown();
                      }}>
                        Kayıt Ol
                      </Link>
                      <Link to="/login" className="dropdown-item list-group-item list-group-item-action fs-6 fs-7" onClick={() => {
                        closeDropdown();
                      }}>
                        Giriş Yap
                      </Link>
                      <Link to="/openStore" className="dropdown-item list-group-item list-group-item-action fs-6 fs-7" onClick={() => {
                        closeDropdown();
                      }}>
                        Mağaza Aç
                      </Link>

                    </div>
                  )}
                </div>

              </div>
              <div>
                <div className="header-favorite">
                  <a href="/favorite" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'black', gap: '6px' }}>
                    <FaHeart style={{ fontSize: '16px', color: 'red' }} />
                    <span className="fs-6 fs-7">Favoriler</span>
                  </a>

                </div>

              </div>
              <div className="cart">

                <div
                  className="cart-icon d-flex gap-2 align-items-center p-0"
                  onMouseEnter={() => setIsHovering(true)}
                  onMouseLeave={() => setIsHovering(false)}
                  onClick={() => setIsHovering(false)}
                  style={{ position: 'relative' }}
                >
                  <i className="fas fa-shopping-cart" onClick={() => navigate("/card")}></i>
                  <span className="fs-6 fs-7 cart-info" onClick={() => navigate("/card")}> Sepetim</span>
                  <span className="cart-count rounded-circle" >{cartCount}</span>

                  {isHovering && (

                    <div className="cart-dropdown">
                      {cart.length === 0 ? (
                        <p className="fs-6 fs-7 mb-0 p-2">Sepetiniz boş</p>
                      ) : (<>
                        <h4 className="fs-6 fs-7">Sepetim ({cartCount})</h4>
                        {cart.map((item, i) => {
                          const imageUrl = item.image && item.image.i1
                            ? (item.image.i1.startsWith('http') ? item.image.i1 : `https://panel.bikuyum.com/upload/${item.image.i1}`)
                            : 'https://panel.bikuyum.com/assets/images/no-image.png';

                          return (
                            <div key={i} className="cart-item d-flex align-items-center">
                              <div className="cart-item-image">
                                <a href={`/urun/${item.sef}`}>
                                  <img
                                    src={imageUrl}
                                    alt={item.name || 'Ürün'}
                                    onError={(e) => {
                                      console.log("Resim yüklenemedi, varsayılan resim kullanılıyor");
                                      e.target.src = 'https://panel.bikuyum.com/assets/images/no-image.png';
                                    }}
                                  />
                                </a>

                              </div>
                              <div className="cart-item-details">
                                <a href={`/urun/${item.sef}`}><p className="product-title">{item.baslik}</p></a>
                                <p className="cart-item-details-price"> {item.fiyat} TL</p>
                              </div>
                            </div>
                          );
                        })}
                        <button className="cart-button d-block ms-auto" onClick={() => navigate("/card")}>

                          Sepete Git
                        </button>
                      </>

                      )}


                    </div>
                  )}
                </div>

              </div>
            </div>
          </div>
          <div className="menu">
            <Categories />
          </div>

        </div>
      {/* </Container> */}
    </>
  );
};
export default Header;